import { render, staticRenderFns } from "./SingleCourse.vue?vue&type=template&id=3d94aeed&scoped=true"
import script from "./SingleCourse.vue?vue&type=script&lang=js"
export * from "./SingleCourse.vue?vue&type=script&lang=js"
import style0 from "./SingleCourse.vue?vue&type=style&index=0&id=3d94aeed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d94aeed",
  null
  
)

export default component.exports